import { useState } from "react"

import Style from "./style"

import PageTitle from "widget/PageTitle"
import ImageModal from "widget/ImageModal"

import useGetNoticeDetail from "entity/column/useGetNoticeDetail"

import timestampCalculator from "shared/lib/timestampCalculator"

const NoticeDetail = () => {
    const [expandImgSrc, setExpandImgSrc] = useState(null)

    const [noticeData] = useGetNoticeDetail()

    return (
        <>
            {expandImgSrc && <ImageModal src={expandImgSrc} closeEvent={() => setExpandImgSrc(null)} />}

            <Style.Wrapper>
                <PageTitle>공지사항</PageTitle>

                <Style.Content>

                    <Style.TitleDiv>
                        <h2>{noticeData?.data?.title}</h2>
                        <p>{timestampCalculator(noticeData?.data?.created_at)}</p>
                    </Style.TitleDiv>

                    <p>{noticeData?.data?.content}</p>

                    <Style.ImgList>
                        {noticeData?.data?.img_list.map(elem =>
                            <img src={elem} onClick={() => setExpandImgSrc(elem)} />
                        )}
                    </Style.ImgList>

                </Style.Content>

            </Style.Wrapper>
        </>
    )
}

export default NoticeDetail